import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import GlobalContext from '../../contexts/GlobalContext';

const FooterSupport = (): JSX.Element => {
  const { globalContext } = useContext(GlobalContext);
  const contactEmail = globalContext.liquid.settings.contact_email || '';
  const footerEmail = globalContext.liquid.settings.footer_email_us;
  const contactPhone = globalContext.liquid.settings.contact_phone;
  const contactPhoneNumberForm = globalContext.liquid.settings.contact_phone_number_form || '';
  const talkToUs = globalContext.liquid.settings.footer_talk_to_us;
  const contactUsUrl = globalContext.liquid.supportUrl || '';
  const footerContactUs = globalContext.liquid.settings.footer_contact_us;
  const footerTalkToUsText = globalContext.liquid.settings.footer_talk_to_us_text;

  return (
    <div className="footer-block" id="footerSupportSection">
      <h4 className="footer-block__heading">Support</h4>
      <ul className="no-bullet footer-block__list">
        <li className="footer-block__list-item">
          <Link
            to={{ pathname: `mailto:${contactEmail}` }}
            target='_blank'
            className='footer-block__list-link'
            onClick={(event): void => {
              globalContext.gtm.pushLinkEvent(event, 'Footer_ClickEmailUs');
            }}>
            {footerEmail}
          </Link>
        </li>
        {contactPhone && (
          <>
            <li className="footer-block__list-item">
            <span className="talk-text">{footerTalkToUsText}</span>
              <Link
                to={{ pathname: `tel:${contactPhoneNumberForm}` }}
                target='_blank'
                className='footer-block__list-link'
                onClick={(event): void => {
                  globalContext.gtm.pushLinkEvent(event, 'Footer_ClickPhone');
                }}>
                {contactPhone}
              </Link>
            </li>
            <li className="footer-block__list-item">{parse(talkToUs)}</li>
          </>
        )}
        <li className="footer-block__list-item">
          <Link
            to={{ pathname: contactUsUrl }}
            id="help_link"
            target="_blank"
            className='footer-block__list-link'
            onClick={(event): void => {
              globalContext.gtm.pushLinkEvent(event, 'Footer_ClickHelpContact');
            }}>
            {footerContactUs}
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default FooterSupport;
